// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Qo7j","label":"styles_label__NJjFu"};